import { getAppText } from 'Utils/text';
import { object, string } from 'yup';

export const getEmailCancellationFormValidation = () => {
  return object({
    manualMessage: string()
      .min(
        6,
        getAppText('cancelInsurance.manualMessage.error.manualMessage.length'),
      )
      .max(
        1000,
        getAppText('cancelInsurance.manualMessage.error.manualMessage.length'),
      )
      .required(
        getAppText(
          'cancelInsurance.manualMessage.error.manualMessage.required',
        ),
      ),
  });
};
